import {Grid, GridCell} from '@rmwc/grid';
import AlertMessage from '../common/AlertMessage';
import {FormattedMessage, useIntl} from 'react-intl';
import ProductType from '../../const/productType';
import React from 'react';
import moment from 'moment/moment';
import RadioField from '../common/RadioField';
import TableList from '../common/TableList';
import { DialogButton } from '@rmwc/dialog';
import ContractProductTypeEnum from '../../const/productType';

export const CustomerProductSelectionTable = ({
  selectedDatePeriods,
  onDatePeriodSelect,
    primaryProductId,
    primaryProductType,
    primaryProductMargin,
    connectedProductId,
    connectedProductMargin,
}) => {
  const intl = useIntl();

    const getStockProductMargin = () => {
        return primaryProductType === ContractProductTypeEnum.StockPrice
            ? primaryProductMargin
            : connectedProductMargin;
    };

    const getFixedProductMargin = () => {
        return primaryProductType === ContractProductTypeEnum.StockPrice
            ? connectedProductMargin
            : primaryProductMargin;
    };

    const getStockProductId = () => {
        return primaryProductType === ContractProductTypeEnum.StockPrice
            ? primaryProductId
            : connectedProductId;
    };

    const getFixedProductId = () => {
        return primaryProductType === ContractProductTypeEnum.StockPrice
            ? connectedProductId
            : primaryProductId;
    };

  const renderPriceColumn = (index) => {
    const selectedValue = selectedDatePeriods[index];

    switch (selectedValue?.type) {
      case ProductType.FixedPrice:
        return intl.formatMessage(
            {id: 'Product.VariableProduct.Price.FixedPrice'},
            {margin: getFixedProductMargin()});
      case ProductType.StockPrice:
        return intl.formatMessage(
            {id: 'Product.VariableProduct.Price.StockPrice'},
            {margin: getStockProductMargin()});
      default:
        return intl.formatMessage({id: 'Product.VariableProduct.Price.Select'});
    }
  };

  const renderStockPriceSelection = (row, index, label = undefined) =>
      <RadioField
          wrapperClasses={'override-mdc-form-field'}
          index={index}
          fieldName={`variableProduct_stock_${index}`}
          fieldValue={ProductType.StockPrice}
          fieldLabel={label}
          selectedValue={row.type}
          disabled={false}
          onChange={() => {
            const previous = [...selectedDatePeriods];
            previous[index] = {
              ...previous[index],
              date: row.date,
              type: ProductType.StockPrice,
              productId: getStockProductId(),
            };
            onDatePeriodSelect(previous);
          }}
      />;

  const renderFixPriceSelection = (row, index, label = undefined) =>
      <RadioField
          wrapperClasses={'override-mdc-form-field'}
          index={index}
          fieldName={`variableProduct_fix_${index}`}
          fieldValue={ProductType.FixedPrice}
          fieldLabel={label}
          selectedValue={row.type}
          disabled={false}
          onChange={() => {
            const previous = [...selectedDatePeriods];
            previous[index] = {
              ...previous[index],
              date: row.date,
              type: ProductType.FixedPrice,
              productId: getFixedProductId(),
            };
            onDatePeriodSelect(previous);
          }}
      />;

  const renderMobileItem = (row, index) =>
      <div className="d-flex d-flex--inline flex-dir-column p-10">
        <div className="d-flex d-flex--inline justify-content-between">
          <span className="capitalize text-bold">{moment(row.date).
              format('MMMM YYYY')}</span>
          <span className=" text-right">{renderPriceColumn(index)}</span>
        </div>

        <div className="d-flex d-flex--inline mt-20">
          <div className="flex-fill">
            {renderStockPriceSelection(row, index, intl.formatMessage(
                {id: `ProductType.${ProductType.StockPrice}`}))}
          </div>
          <div className="flex-fill">
            {renderFixPriceSelection(row, index, intl.formatMessage(
                {id: `ProductType.${ProductType.FixedPrice}`}))}
          </div>
        </div>
      </div>;

  return (
      <Grid>
        <GridCell span={12}>
          <AlertMessage
              type={AlertMessage.TYPE_NOTICE}
              title={intl.formatMessage(
                  {id: 'Product.VariableProduct.Disclaimer'})}
              isSmall
          />
        </GridCell>
        <GridCell span={12}>
          <TableList
              headers={[
                {
                  label: 'Product.VariableProduct.Header.Month',
                  style: {width: '20%'},
                },
                {
                  label: 'Product.VariableProduct.Header.Price',
                  style: {width: '60%'},
                },
                {label: `ProductType.${ProductType.StockPrice}`},
                {label: `ProductType.${ProductType.FixedPrice}`},
              ]}
              itemContent={selectedDatePeriods.map((row, index) => {
                return {
                  content: [
                    {
                      content: <span className="capitalize">{moment(row.date).
                          format('MMMM YYYY')}</span>,
                    },
                    {content: renderPriceColumn(index)},
                    {content: renderStockPriceSelection(row, index)},
                    {content: renderFixPriceSelection(row, index)},
                  ],
                };
              })}
              hideMobileHeader={true}
              mobileHeaders={[
                {label: <div>&nbsp;</div>},
              ]}
              mobileItemContent={selectedDatePeriods.map((row, index) => (
                  {
                    content: [
                      {content: renderMobileItem(row, index)},
                    ],
                  }
              ))}
          />
        </GridCell>
      </Grid>
  );
};